var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SvoiButtonLink',_vm._g(_vm._b({attrs:{"link":_vm.link,"component-type":_vm.componentType}},'SvoiButtonLink',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }